var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      style: {
        height: `${_vm.paperHeight}mm`,
        width: `${_vm.paperWidth}mm`,
        padding: 0,
      },
      attrs: { fluid: "" },
    },
    [
      _vm._l(_vm.pages, function (page, i) {
        return [
          i
            ? _c("div", {
                key: "break-before-" + i,
                style: {
                  pageBreakBefore: `always`,
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              key: `page-${i}`,
              style: {
                height: "100%",
                padding: `${_vm.paperPaddingY}mm ${_vm.paperPaddingX}mm`,
              },
            },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                _vm._l(page, function (item, j) {
                  return _c(
                    "v-col",
                    { key: `barcode-${i}-${j}`, attrs: { cols: item.colSize } },
                    [
                      _c(
                        "div",
                        {
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            margin: `${_vm.itemMarginY / 2}mm ${
                              _vm.itemMarginX / 2
                            }mm`,
                            padding: `${_vm.elementMarginY / 2}mm ${
                              _vm.elementMarginX / 2
                            }mm`,
                            border: "0.27607px solid #6C6C6C",
                            width: `${_vm.itemWidth}mm`,
                            height: `${_vm.itemHeight}mm`,
                            overflow: "hidden",
                          },
                        },
                        _vm._l(_vm.elements, function (el, k) {
                          return _c(
                            "div",
                            {
                              key: `barcode-${i}-${j}-${k}-${el}`,
                              style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                flexGrow: el === "barcode" ? 1 : 0,
                                lineHeight:
                                  el === "barcode"
                                    ? 0
                                    : `${_vm.itemLineHeight}px`,
                                fontSize:
                                  el === "barcode"
                                    ? 0
                                    : `${_vm.itemFontSize}px`,
                              },
                            },
                            [
                              el === "name"
                                ? [
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          margin: `${
                                            _vm.elementMarginY / 2
                                          }mm ${_vm.elementMarginX / 2}mm`,
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item.name) + " ")]
                                    ),
                                  ]
                                : el === "barcode"
                                ? [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(item.canvas),
                                      },
                                    }),
                                  ]
                                : el === "price"
                                ? [
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          margin: `${
                                            _vm.elementMarginY / 2
                                          }mm ${_vm.elementMarginX / 2}mm`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.toLocaleString(item.price)
                                            ) +
                                            " บาท "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }